import { render, staticRenderFns } from "./helloworld2.vue?vue&type=template&id=f1ac3232&"
import script from "./helloworld2.vue?vue&type=script&lang=js&"
export * from "./helloworld2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ac3232')) {
      api.createRecord('f1ac3232', component.options)
    } else {
      api.reload('f1ac3232', component.options)
    }
    module.hot.accept("./helloworld2.vue?vue&type=template&id=f1ac3232&", function () {
      api.rerender('f1ac3232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/helloworld2.vue"
export default component.exports